import { render, staticRenderFns } from "./googlelogin.vue?vue&type=template&id=531a0bf8"
import script from "./googlelogin.vue?vue&type=script&lang=js"
export * from "./googlelogin.vue?vue&type=script&lang=js"
import style0 from "./googlelogin.vue?vue&type=style&index=0&id=531a0bf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports